export enum RepresentativeRole {
  BUSINESS_ADMIN = 'BUSINESS_ADMIN',
  BUSINESS_REPRESENTATIVE = 'BUSINESS_REPRESENTATIVE',
  RESELLER = 'RESELLER',
  REGIONAL_ADMIN = 'REGIONAL_ADMIN',
}
